import React, { useEffect, useRef, useState } from "react";
import useButtonStyles from "../../styles/useButtonStyles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import theme from "../../theme";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import formatDate from "../../util/dateFormat";
import { useParams } from "react-router-dom";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import { getReceipts } from "../../services/ApiServices/Receipts";
import { getEncodedLastkey, getEncodedValue } from "../forms/utility";
import {
  SearchToolTip,
  filterConstants,
  DateConstants,
  modelName,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from "../../services/ApiServices/export";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";

interface TableColumn {
  key: string;

  header: string;

  searchable?: boolean;

  filterable?: boolean;
}
const metaData = {
  image: {
    isImage: true,
    linkTo: "",
  },
  memberName: {
    isImage: false,
    linkTo: "",
  },
  memberId: {
    isImage: false,
    linkTo: "",
  },
  loyaltyCardNo: {
    isImage: false,
    linkTo: "",
  },
  amountBpo: {
    isImage: false,
    linkTo: "",
  },
  amountMember: {
    isImage: false,
    linkTo: "",
  },
  submissionDate: {
    isImage: false,
    linkTo: "",
  },
  reviewedDate: {
    isImage: false,
    linkTo: "",
  },
  rejectionDate: {
    isImage: false,
    linkTo: "",
  },
  tallyCheck: {
    isImage: false,
    linkTo: "",
  },
  tallyCheckMessage: {
    isImage: false,
    linkTo: "",
  },
  status: {
    isImage: false,
    linkTo: "",
  },
  receiptType: {
    isImage: false,
    linkTo: "",
  },
};
const listOfStatus = [
  filterConstants.Processing.toLowerCase(),
  filterConstants.Accept.toLowerCase(),
  filterConstants.Reject.toLowerCase(),
  filterConstants.Pending.toLowerCase(),
  filterConstants.Appeal.toLowerCase(),
];
const MerchantReceiptNew = () => {
  const columns: TableColumn[] = [
    { key: "image", header: "Image" },
    { key: "memberName", header: "Member" },
    { key: "loyaltyCardNo", header: "Loyalty Card No" },
    { key: "receipt_number", header: "Receipt Number" },
    { key: "amountMember", header: "Uploaded Amount" },
    { key: "adjustedAmount", header: "Adjusted Amount" },
    { key: "submissionDate", header: "Submitted Date" },
    { key: "reviewedDate", header: "Reviewed Date" },
    { key: "rejectionDate", header: "Reject Date" },
    { key: "status", header: "Status" },
    { key: "receiptType", header: "Receipt Type" },
    { key: "remark", header: "Remark" },
  ];

  const [data, setData] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const buttonStyles = useButtonStyles();
  const params = useParams();
  const { merchantId } = params;
  const [emailSent, setEmailSent] = useState(false);
  const [exportEmail, setExportEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [open, setOpen] = useState(false);
  const [initialApiCall, setInitialApiCall] = useState(true);
  const [apiFromKey, setApiFromKey] = useState<Number>(0);
  const [totalDataCount, setTotalDataCount] = useState<Number>(0);
  const [nextPageKey, setNextPageKey] = useState<any>(null);
  const [filterActive, setFilterActive] = useState(false);
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();
  const ListReceipts = async (
    urlString?: string,
    canHaveExistingData?: boolean
  ) => {
    let baseParams = `fromKey=${apiFromKey}`;
    if (urlString) baseParams += `&${urlString}`;
    baseParams += `&module=merchant&feature=receipts`;
    if (nextPageKey) baseParams += `&${getEncodedLastkey(nextPageKey)}`;
    try {
      setLoading(true);
      const receiptsLists = await getReceipts(baseParams);
      const { lastKey, result, fromKey, totalCount } = receiptsLists;
      setApiFromKey(fromKey);
      setTotalDataCount(totalCount);
      const dataKey = lastKey ? lastKey : null;
      setNextPageKey(dataKey);
      const receiptsData = result?.map((data: any) => {
        const item = data?._source;
        return {
          image: item.upload_log[0].receipt_image,
          memberName: item.member_name ? item.member_name : "-",
          loyaltyCardNo:
            item.loyalty_card_no === "" ? "-" : item.loyalty_card_no,
          adjustedAmount: `S$ ${item.amount_bpo}`,
          amountMember: `S$ ${item.amount_member}`,
          paymentType: item.payment_type ? item.payment_type : "-",
          submissionDate: formatDate(item.submission_date),
          receipt_number: item.receipt_number ? item.receipt_number : "-",
          reviewedDate:
            item.reviewed_date !== 0 ? formatDate(item.reviewed_date) : "-",
          rejectionDate:
            item.upload_log.filter((log: any) => log.status === "reject")
              .length === 0
              ? "-"
              : formatDate(
                  item.upload_log.filter(
                    (log: any) => log.status === "reject"
                  )[0].upload_time
                ),

          status: item.receipt_status,
          receiptType: item.receipt_type,
          remark: item.remarks,

          id: item.id ? item.id : "-",
        };
      });
      const dataToSet = canHaveExistingData
        ? [...data, ...receiptsData]
        : receiptsData;
      setData(dataToSet);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  // Export Functionality
  const formatCSVData = (data: any) => {
    return data?.map((csvRow: any) => {
      const rowWithoutNavigateTo = { ...csvRow };
      delete rowWithoutNavigateTo.navigateTo;
      return rowWithoutNavigateTo;
    });
  };

  const handleSendExport = async () => {
    const getFilterURL = getFilteParams()
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.receiptSuntec,
      "",
      ""
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };
  // };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const exportHeaders = Object.keys(data).filter((key) => key !== "navigateTo");
  const dataToConvert = {
    data: data,
    filename: "merchant_receipts",
    delimiter: ",",
    headers: exportHeaders,
  };
  // filter and search UI
  const [filterState, setFilterState] = useState({
    submittedDate: "",
    reviewedDate: "",
    status: "",
    createdAt: "",
  });

  const resetFilterState = () => {
    setFilterState({
      submittedDate: "",
      reviewedDate: "",
      status: "",
      createdAt: "",
    });
    setFilterStates([
      { fieldValue: "merchant", value: `${merchantId}`, operator: "eq" },
    ]);
    onReset()
    setInitialApiCall(true);
  };
  const [filterStates, setFilterStates] = useState<any>([
    { fieldValue: "merchant", value: `${merchantId}`, operator: "eq" },
  ]);

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };

  const HandleStatusChange = (event: SelectChangeEvent) => {
    getAllFields(
      "receipt_status",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };
  const searchInputRef = useRef<HTMLInputElement>();
  
  const getFilteParams=()=>{
    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const params = {
      searchData: searchParam,
      filterData: filterStates,
    };
    return getHashURL(params);
  }
  
  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
   const url = getFilteParams()
    // if (!data.length)
    //  getTotalRecordsCount(APIModuleConstants.receipt, url);
    ListReceipts(url, canHaveExistingData);
    setInitialApiCall(false);
    return url;
  };
  const applyFilterReceipts = () => {
    onReset();
    setInitialApiCall(true);
    setOpenFilter(false);
    const filteringData = filterStates.slice(1);
    filteringData && setFilterActive(true);
  };
  // search
  const handleSearch = () => {
    onReset();
    setInitialApiCall(true);
  };

  const onReset = () => {
    setData([]);
    setApiFromKey(0);
    setTotalDataCount(0)
    setNextPageKey(null);
  };
  useEffect(() => {
    if (initialApiCall) bindSearchAndFilter();
  }, [initialApiCall]);
  const { getUserPermission: getMerchantPermission } = usePermissionGetter(
    "merchant",
    "receipts"
  );
  return (
    <Grid
      sx={{ background: theme.color?.background, borderRadius: "16px" }}
      display={"flex"}
      flexDirection={"column"}
      overflow={"hidden"}
      width={"100%"}
    >
      <Dialog onClose={handleCloseFilter} open={openFilter} sx={{ ml: "60vw" }}>
        <Grid sx={{ width: "484px", py: 4, px: 2 }}>
          <DialogTitle
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thicker,
              }}
            >
              Filter
            </Typography>
            {/* <IconButton onClick={() => setOpenFilter(false)}> */}
            <IconButton
              onClick={() => {
                setOpenFilter(false);
              }}
            >
              <CloseOutlinedIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
            <Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Submitted Date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "80%",
                    }}
                    type="date"
                    size="small"
                    placeholder="Transaction Date"
                    value={filterState.createdAt}
                    onChange={(e) => {
                      getAllFields(
                        "createdAt",
                        new Date(e.target.value).getTime(),
                        operatorConstants.equal
                      );
                      setFilterState((prev) => ({
                        ...prev,
                        createdAt: e.target.value,
                      }));
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Reviewed Date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "80%",
                    }}
                    type="date"
                    size="small"
                    placeholder="Transaction Date"
                    value={filterState.reviewedDate}
                    onChange={(e) => {
                      getAllFields(
                        "reviewed_date",
                        new Date(e.target.value).getTime(),
                        operatorConstants.equal
                      );
                      setFilterState((prev) => ({
                        ...prev,
                        reviewedDate: e.target.value,
                      }));
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Status
                </Typography>
                <Grid
                  gap={2}
                  mt={2}
                  display={"flex"}
                  sx={{
                    width: "80%",
                  }}
                >
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{
                      with: "100%",
                    }}
                  >
                    <Select
                      id=""
                      value={filterState.status}
                      onChange={HandleStatusChange}
                    >
                      {listOfStatus.map((name: any) => (
                        <MenuItem value={name}>{name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
            <Button
              sx={{ ...buttonStyles.outlinedSecondary }}
              onClick={() => {
                resetFilterState();
              }}
            >
              Reset
            </Button>
            <Button
              sx={{ ...buttonStyles.containedSecondary }}
              onClick={applyFilterReceipts}
            >
              Apply
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
      <ExportDialog
        closeDialog={setOpen}
        emailSent={emailSent}
        exportTitle="Merchant Receipt"
        handleClose={handleClose}
        open={open}
        sending={sending}
        handleSendExport={handleSendExport}
      />
      <Grid display={"flex"} justifyContent={"space-between"} px={4} py={3}>
        {getMerchantPermission("export") && (
          <Button
            sx={{ ...buttonStyles.textSecondary }}
            onClick={() => {
              setOpen(true);
            }}
          >
            Export Details
          </Button>
        )}
        <Grid display={"flex"} gap={3}>
          <SearchInput
            HelpTip={SearchToolTip.MemberReceipts}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
          <Button
            variant="text"
            startIcon={
              filterActive ? (
                <FilterAltIcon sx={{ color: theme.color?.secondary }} />
              ) : (
                <FilterAltOutlinedIcon />
              )
            }
            sx={{
              color: theme.color?.newFilterGrey,
              textTransform: "capitalize",
            }}
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            Filter
          </Button>
        </Grid>
      </Grid>
      <Grid p={2}>
        <InfiniteTable
          header={columns}
          contentItems={data}
          metaData={metaData}
          isInitialLoading={data.length === 0 && loading}
          hasMoreRecords={nextPageKey !== null}
          totalRecords={totalDataCount}
          fetchMoreData={() => bindSearchAndFilter(true)}
        />
      </Grid>
    </Grid>
  );
};

export default MerchantReceiptNew;
